
import { PartialBrandingConfig } from './branding.models';
export const BRANDINGS: Record<string, PartialBrandingConfig> = {
};
